var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60661 3.79492H6.96289V4.77023H8.60661C9.0954 4.77023 9.47463 5.01991 9.47463 5.2348V9.55964C9.47463 9.77453 9.0954 10.0242 8.60661 10.0242H2.39358C1.90479 10.0242 1.52555 9.77453 1.52555 9.55964V5.23496C1.52555 5.02007 1.90479 4.77039 2.39358 4.77039H4.03697V3.79508H2.39358C1.35991 3.79508 0.550247 4.42757 0.550247 5.23496V9.5598C0.550247 10.3674 1.35991 10.9997 2.39358 10.9997H8.60677C9.64027 10.9997 10.4501 10.3672 10.4501 9.5598V5.23496C10.4499 4.42741 9.64027 3.79492 8.60661 3.79492Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05674 2.43095C4.18158 2.43095 4.30626 2.38333 4.40151 2.28807L5.01205 1.67753V3.79524V4.77055V6.63891C5.01205 6.90826 5.23036 7.12657 5.49971 7.12657C5.76905 7.12657 5.98736 6.90826 5.98736 6.63891V4.77055V3.79524V1.64453L6.6309 2.28807C6.72616 2.38333 6.851 2.43095 6.97567 2.43095C7.10035 2.43095 7.22519 2.38333 7.32044 2.28807C7.51095 2.09772 7.51095 1.78888 7.32044 1.59853L5.86447 0.142557C5.76922 0.0473024 5.64454 0 5.51986 0C5.51856 0 5.51743 0 5.51612 0C5.51482 0 5.51369 0 5.51239 0C5.38771 0 5.26303 0.0473024 5.16778 0.142557L3.71181 1.59853C3.5213 1.78888 3.5213 2.09772 3.71181 2.28807C3.80722 2.38333 3.9319 2.43095 4.05674 2.43095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/downloadWhite.c08945b3f0d07f0df8e94590c75daadd.svg";
export { ForwardRef as ReactComponent };